import React from 'react'


export default function Footer() {
  return (

    <footer className="text-center text-lg-start bg-primary text-light ">
      <div className="text-center p-3" >
        Copyright 2024 © {document.title}. All Rights Reserved.
      </div>
    </footer >
  )
}
